export default __webpack_public_path__ + "static/ddfdef0d-992a-43af-8c88-9f818f694935-dcefaf92c6445898ed54ef62454b4a47.jpg";